import React, { useState } from 'react'
import { FormControl, InputLabel, Select, Input, MenuItem, Grid, Typography, FormHelperText } from '@material-ui/core'
import BusinessIcon from '@material-ui/icons/Business'
import { Account } from 'types/Account'
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer'

interface Props {
  classes: any,
  selected: null | Account,
  options: Account[],
  disabled?: boolean,
  onChange?(account: Account): void,
  helperText?: string,
}

const AccountSelector = (props: Props) => {
  const {
    classes,
    selected = null,
    options = [],
    disabled = false,
    onChange = () => {},
    helperText,
  } = props
  const onSelectAccountHandler = async (accountId: string) => {
    const account = options.find((account) => account.id === accountId)
    if (account) {
      onChange(account)
    }
  }
  return (
    <FormControl fullWidth>
      <InputLabel htmlFor='place-order-account-selector'>Account</InputLabel>
      <Select
        disabled={disabled}
        fullWidth
        renderValue={(value) => (
          <React.Fragment>
            <BusinessIcon className={classes.dropdownIcon} />
            {selected ? selected.name : ''}
          </React.Fragment>
        )}
        value={selected !== null ? selected.id : '' }
        onChange={(e) => onSelectAccountHandler(e.target.value as string)}
        input={<Input name='name' id='place-order-account-selector' />}
      >
        {options.map((account: Account) => {
          return (
            <MenuItem value={account.id} key={account.id} data-mf-replace-inner={MFSDR}>
              <Grid container>
                <Grid item xs={12}>
                  {account.name}
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='caption' className={classes.opacity05}>
                    Account ID: {account.id.trim()}
                  </Typography>
                </Grid>
              </Grid>
            </MenuItem>
          )
        })}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}

export default AccountSelector
